import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { AddSearchAbo } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'search-abo',
    events: {
        'Submit Search Abo Form': props<{ data: AddSearchAbo }>(),
        'Submit Search Abo Success': emptyProps(),
        'Submit Search Abo Error': emptyProps(),

        'DOI Search Abo': props<{ guid: string }>(),
        'DOI Search Abo Success': emptyProps(),
        'DOI Search Abo Error': emptyProps(),

        'Cancel Search Abo': props<{ guid: string }>(),
        'Cancel Search Abo Success': emptyProps(),
        'Cancel Search Abo Error': emptyProps(),
    },
});
